import { Chip } from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../Api";
import { IAuditedMaterial, IComboBoxOption, IMaterialAudit } from "../../interfaces";
import { Values } from "../../utils";

export const useMaterialAudit = () => {

    const [audit, setAudit] = useState<IMaterialAudit>();
    const [detailsValid, setDetailsValid] = useState<boolean>(false);

    const [materialStates, setMaterialStates] = useState<IComboBoxOption[]>([]);


    const [bread, setBread] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);

    const { maId } = useParams();

    const navigate = useNavigate();

    const fetchFormData = async (id: string | null | undefined) => {
        if (id) {
            return Api.Audits.get(id);
        }
    }

    const populateForm = (data: IMaterialAudit) => {

        if (data) {

            if (data.dateNextAudit === "")
                data.dateNextAudit = null;


            console.log("populating audit", data);

            setAudit(data);
        }

        setLoading(false);
    }


    const onUpdateAuditDetail = useCallback(
        (updatedAudit: IMaterialAudit) => {
            setLoading(true);
            setAudit((prevAudit) => {
                const newAudit = { ...prevAudit, ...updatedAudit };
                Api.Audits.save(newAudit).then(() => {
                    setLoading(false);
                });
                return newAudit;
            });
        },
        [setAudit, setLoading]
    );

    const onUpdateResponsibleFleetEngineer = (value: string) => {

        let updatedAudit = cloneDeep(audit);
        if (updatedAudit) {


            updatedAudit.responsibleFleetEngineer = value;
            onUpdateAuditDetail(updatedAudit);
        }
    };

    const onUpdateDateAudit = (date: string | null) => {
        console.log("update date audit", date);

        let updatedAudit = cloneDeep(audit);
        if (updatedAudit) {
            updatedAudit.dateAudit = date === null ? null : new Date(date).toISOString();

            if (date) {
                const auditDate = new Date(date);
                auditDate.setFullYear(auditDate.getFullYear() + 1);
                updatedAudit.dateNextAudit = auditDate.toISOString();
            }

            onUpdateAuditDetail(updatedAudit);
        }
    };

    const onUpdateDateNextAudit = (date: string | null) => {
        console.log("update next audit", date);

        let updatedAudit = cloneDeep(audit);
        if (updatedAudit) {
            updatedAudit.dateNextAudit = date === null ? null : new Date(date).toISOString();
            onUpdateAuditDetail(updatedAudit);
        }
    };





    const validateDetails = (ma: IMaterialAudit | undefined) => {

        if (!ma || !ma?.dateNextAudit || !ma.dateAudit || !ma.responsibleFleetEngineer) {
            setDetailsValid(false);
            return;
        } else {
            let result = true;

            //audit?.materialAuditResults.forEach(x => {
            //    if (
            //        !x.stateAudit ||
            //        x.qtyAudit === undefined ||
            //        !x.storageReasonAudit ||
            //        !x.retentionDecision
            //    ) {
            //        console.log("Not all material audits have the necessary details completed");
            //        result = false;
            //    }
            //});

            setDetailsValid(result);
        }
    }



    const onDelete = async () => {
        setLoading(true);

        return Api.Audits.delete(audit?.materialAuditId as string).then(async (r) => {

            navigate("/audit");

        })
    }

    const onClose = async () => {
        setLoading(true);

        return Api.Audits.close(audit?.materialAuditId as string).then(async (r) => {

            fetchFormData(audit?.materialAuditId).then((data: any) => {
                populateForm(data);
                setLoading(false);

            });

        });
    }

    const onReload = () => {
        fetchFormData(maId).then((data: any) => {
            populateForm(data);
        });
    }

    const getStatus = () => { return audit?.status ?? 0 }

    const getStatusLabel = () => {

        //if (loading)
        //    return <CircularProgress size="2rem" />;

        switch (getStatus()) {
            case 1:
                return <Chip
                    label={"In Progress - Open"}
                    color="primary"
                    variant="outlined"
                />;
            case 2:
            case 3: return <Chip
                label={"Complete - Closed"}
                color="primary"
                variant="outlined"
            />;
            //case 3: return <Chip
            //    label={"Failed - Closed"}
            //    color="primary"
            //    variant="outlined"
            ///>;

            default:
                return <Chip
                    label={"..."}
                    style={{ minWidth: '4rem' }}
                    color="primary"
                    variant="outlined"
                />;
        }

    }

    const isReadonly = () => {
        return ![1].includes(getStatus());
    }

    const onExportResults = () => {

        setLoading(true);
        if (audit && audit.materialAuditId)
            Api.Audits.export(audit.materialAuditId)
                .then((response: any) => response.blob())
                .then((blob) => {

                    const filename = `${audit.reference} - ${new Date().toUTCString()}.csv`;

                    const url = window.URL.createObjectURL(
                        new Blob([blob]),
                    );

                    const link: HTMLAnchorElement = document.createElement('a');

                    link.href = url;
                    link.setAttribute(
                        'download',
                        filename,
                    );
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode?.removeChild(link);

                    setLoading(false);
                }).catch((r) => {
                    console.log("error while exporting", r);
                    setLoading(false);
                });


    }

    const onImportResults = (results: { materials: IAuditedMaterial[] }) => {

        console.log("handle results", results);

        let materialAudit = { ...audit } as IMaterialAudit;
        if (materialAudit) {
            results.materials.forEach(auditedMaterial => {
                let thisMaterialAuditResult = materialAudit.materialAuditResults?.filter(x => x.material.materialId === auditedMaterial.materialId)[0];
                if (thisMaterialAuditResult) {
                    thisMaterialAuditResult.qtyAudit = auditedMaterial.qtyAudit;
                    thisMaterialAuditResult.stateAudit = auditedMaterial.stateAudit;
                    thisMaterialAuditResult.storageReasonAudit = auditedMaterial.storageReasonAudit;
                    thisMaterialAuditResult.retentionDecision = auditedMaterial.retentionDecision;
                    thisMaterialAuditResult.auditComments = auditedMaterial.auditComments;
                }
            });

            console.log("updated materials", materialAudit);
            onUpdateAuditDetail(materialAudit);
        }
    }

    useEffect(() => {

        let requestedId: any = maId;
        if (requestedId) setBread("Update");
        else {
            navigate('/audit');
        }

        //when opening an existing request we will pass
        //in the id on the fetch request.

        fetchFormData(requestedId).then((data: any) => {
            populateForm(data);
        });

    }, [maId]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        validateDetails(audit);
    }, [audit, loading])

    useEffect(() => {
        if (materialStates.length === 0) {
            Values.setValues("materialstates", setMaterialStates);
        }
    },)

    return {
        models: { bread, detailsValid, audit, materialStates, loading },
        operations: {
            isReadonly,
            getStatusLabel,
            getStatus,
            onReload,
            onDelete,
            onClose,
            onUpdateAuditDetail,
            onUpdateDateAudit,
            onUpdateDateNextAudit,
            onUpdateResponsibleFleetEngineer,
            onExportResults,
            onImportResults
        }
    };
}
